<template>
  <div v-if="isVisible" class="modal">
    <div class="modal-overlay" @click="closeModal"></div>
    <div class="modal-content" ref="modalContent">
      <div class="modal-header">
        <!-- <h2>История изменений заказа</h2> -->
        <button class="close-btn" @click="closeModal">&times;</button>
      </div>
      <div v-if="loading" class="loading">Загрузка...</div>
      <div v-else class="UiTabs-tabs-3VpC" ref="tabl">
        
        <div class="UiTabs-tabs__controls-2RzE">
          <button
            type="button"
            :class="['UiTabs-tabs__control-1-mU', { 'UiTabs-tabs__control_active-2kxM': activeTab === 'statusChanges' }]"
            @click="setActiveTab('statusChanges')"
          >
            Изменения статуса
          </button>
          <button
            type="button"
            :class="['UiTabs-tabs__control-1-mU', { 'UiTabs-tabs__control_active-2kxM': activeTab === 'orderChanges' }]"
            @click="setActiveTab('orderChanges')"
          >
            Изменения заказа
          </button>
        </div>
        <div class="UiTabs-tabs__content-3iY4">
          <div v-show="activeTab === 'statusChanges'" class="UiTabs-tabs-item-lNPO">
            <div class="container_vCNle table_Hb7Zk">
              <table class="table_AJsNp table_fixed_OuwnW">
                <thead>
                  <tr>
                    
                    <!-- <th class="UiText-text-2_z8 UiText-text_black-1BwQ UiText-text_tiny-1_wc cell_eOMiF cell_left_yyJOq">Группа статусов</th> -->
                    <th class="UiText-text-2_z8 UiText-text_black-1BwQ UiText-text_tiny-1_wc cell_eOMiF cell_left_yyJOq">Статус</th>
                    <th class="UiText-text-2_z8 UiText-text_black-1BwQ UiText-text_tiny-1_wc cell_eOMiF cell_left_yyJOq">Кем изменено</th>
                    <th class="UiText-text-2_z8 UiText-text_black-1BwQ UiText-text_tiny-1_wc cell_eOMiF cell_left_yyJOq">Время изменения</th>
                    <th class="UiText-text-2_z8 UiText-text_black-1BwQ UiText-text_tiny-1_wc cell_eOMiF cell_left_yyJOq">Комментарий</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="change in statusChanges" :key="change.id">
                    
                    <!--<td class="UiText-text-2_z8 UiText-text_black-1BwQ UiText-text_small-QTWp cell_OWup9 cell_top_AYyWZ cell_left_eorMY">{{ getCurStatus(change.statusGroup) }}</td>-->
                    <td class="UiText-text-2_z8 UiText-text_black-1BwQ UiText-text_small-QTWp cell_OWup9 cell_top_AYyWZ cell_left_eorMY" style="padding:10px;">

                     <div :class="getGroupByCode(change.newValue)" :style="{ backgroundColor: getColorByCode(change.newValue), borderRadius: '4px' }">
                        <span class="statis" :class="getGroupByCode(change.newValue)"></span>
                        {{ formatOldValue(change.newValue) }}
                      </div>

                    </td>

                    <td class="UiText-text-2_z8 UiText-text_black-1BwQ UiText-text_small-QTWp cell_OWup9 cell_top_AYyWZ cell_left_eorMY">{{ curManager(change.changedBy) }}</td>
                    <td class="UiText-text-2_z8 UiText-text_black-1BwQ UiText-text_small-QTWp cell_OWup9 cell_top_AYyWZ cell_left_eorMY">{{ change.changeTime }}</td>
                    <td class="UiText-text-2_z8 UiText-text_black-1BwQ UiText-text_small-QTWp cell_OWup9 cell_top_AYyWZ cell_left_eorMY">{{ change.comment }}</td>

                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <div v-show="activeTab === 'orderChanges'" class="tab-order-changes-content UiTabs-tabs-item-lNPO">
            <div class="container_vCNle table_KrFDw table_Hb7Zk">
              <table class="table_AJsNp table_fixed_OuwnW">
                <thead>
                  <tr>
                    <th class="UiText-text-2_z8 UiText-text_black-1BwQ UiText-text_tiny-1_wc cell_eOMiF cell_left_yyJOq">Изменённый параметр</th>
                    <th class="UiText-text-2_z8 UiText-text_black-1BwQ UiText-text_tiny-1_wc cell_eOMiF cell_left_yyJOq">Старое значение</th>
                    <th class="UiText-text-2_z8 UiText-text_black-1BwQ UiText-text_tiny-1_wc cell_eOMiF cell_left_yyJOq" style="width: 14px;"></th>
                    <th class="UiText-text-2_z8 UiText-text_black-1BwQ UiText-text_tiny-1_wc cell_eOMiF cell_left_yyJOq">Новое значение</th>
                    <th class="UiText-text-2_z8 UiText-text_black-1BwQ UiText-text_tiny-1_wc cell_eOMiF cell_left_yyJOq">Кем изменено</th>
                    <th class="UiText-text-2_z8 UiText-text_black-1BwQ UiText-text_tiny-1_wc cell_eOMiF cell_left_yyJOq">Время изменения</th>
                  </tr>
                </thead>
                <tbody v-for="(group, index) in groupedOrderChanges" :key="index">
                  <tr v-for="(change, idx) in group.changes" :key="change.id">
                  
                    <td class="UiText-text-2_z8 UiText-text_black-1BwQ UiText-text_small-QTWp cell_OWup9 cell_top_AYyWZ cell_left_eorMY">{{ formatName(change.field) }}</td>

                    <td class="UiText-text-2_z8 UiText-text_black-1BwQ UiText-text_small-QTWp cell_OWup9 cell_top_AYyWZ cell_left_eorMY">
                      <div :class="getGroupByCode(change.oldValue)" :style="{ backgroundColor: getColorByCode(change.oldValue), borderRadius: '4px' }">
                        <span class="statis" :class="getGroupByCode(change.oldValue)"></span>
                        {{ formatOldValue(change.oldValue) }}
                        
                      </div>
                    </td>

                    <td class="UiText-text-2_z8 UiText-text_black-1BwQ UiText-text_small-QTWp cell_OWup9 cell_top_AYyWZ cell_left_eorMY"><svg fill="#000000" height="14px" width="14px" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 330 330" xml:space="preserve"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round" stroke="#CCCCCC" stroke-width="3.3"></g><g id="SVGRepo_iconCarrier"> <path id="XMLID_27_" d="M15,180h263.787l-49.394,49.394c-5.858,5.857-5.858,15.355,0,21.213C232.322,253.535,236.161,255,240,255 s7.678-1.465,10.606-4.394l75-75c5.858-5.857,5.858-15.355,0-21.213l-75-75c-5.857-5.857-15.355-5.857-21.213,0 c-5.858,5.857-5.858,15.355,0,21.213L278.787,150H15c-8.284,0-15,6.716-15,15S6.716,180,15,180z"></path> </g></svg></td>
                    <td class="UiText-text-2_z8 UiText-text_black-1BwQ UiText-text_small-QTWp cell_OWup9 cell_top_AYyWZ cell_left_eorMY">

                      <div :class="getGroupByCode(change.newValue)" :style="{ backgroundColor: getColorByCode(change.newValue), borderRadius: '4px' }">
                        <span class="statis" :class="getGroupByCode(change.newValue)"></span>
                        
                        {{ formatOldValue(change.newValue) }}
                      </div>

                    </td>
                    <td v-if="idx === 0" :rowspan="group.changes.length" class="UiText-text-2_z8 UiText-text_black-1BwQ UiText-text_small-QTWp cell_OWup9 cell_top_AYyWZ cell_left_eorMY">{{ curManager(change.changedBy) }}</td>
                    <td v-if="idx === 0" :rowspan="group.changes.length" class="UiText-text-2_z8 UiText-text_black-1BwQ UiText-text_small-QTWp cell_OWup9 cell_top_AYyWZ cell_left_eorMY">{{ group.time }}</td>
                  </tr>
                </tbody>
              </table>

            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>import { ORDERS_API_BASE } from '@/config/api';

import axios from 'axios';

export default {
  props: {
    isVisible: {
      type: Boolean,
      required: true
    },
    orderId: {
      type: Number,
      required: true
    },
    curiers: {
      type: Array,
      required: true, // Передаем массив менеджеров из основного приложения
    }
  },
  data() {
    return {
      activeTab: 'statusChanges',
      historyData: [],
      loading: false,
      allmanagers: [],
      productNames: [],
      dictionaryOldstat: {
        nepozvonila: 'Не перезвонила',
        hkhjyghj: 'неизвестно',
        "5otlichno": 'Отлично, 5',
        "dozvonilas-i-sms-otpravila": 'Дозвонилась, отправлена смс',
        true: 'Да',
        false: 'Нет',
        tn: 'ТН',
        paid: 'Оплачено',
        "ready-for-assembly": 'Отгружен',
        "assembly-not-delivery": 'Доставляется ТК',
        completed: 'Укомплектован',
        "product-is-damaged": 'Укомплектован',
        base: 'Базовая',
        vozimby: '2. vozim.by',
        cash: 'Наличными',
        "3-predoplata-kartoi": 'Предоплата безналичными',
        new: 'Зарезервирован МС',
        prodan: 'Доставляется курьером',
        courier: '1. Доставка курьером',
        kjivjv9u39oijskj: '4. Магазин',
        "not-paid": "Не оплачен",
        "1akb-by": '---1akb.by---',
        "rassrochka-cherez-bank": 'рассрочка через банк',
        "live-chat": 'Онлайн-консультант',
        "self-delivery": '3. Самовывоз',
        individual: 'Физическое лицо',
        "legal-entity": 'Юридическое лицо',
        saled: 'Продан в магазине',
        grodnomagaz: 'Гродно',
        grodnoooskalad: 'Гродно склад',
        rfhdfnfcrkfl: 'Склад Карвата',
        "exideby": 'exide.by',
        "eshop-individual": 'Физическое лицо',
        "eshop-legal": 'Юридическое лицо',
        "neizvestno": 'неизвестно',
        ukomplektovan: 'Укомплектован',
        "sklad-vitebsk": "Витебск, пр-т. Строителей 12",
        "vitebsk-magazin": "Витебск",
        euro987fh: '7. Европочта',
        fghgfh345lf342g: "Рябов Владислав Русланович ( г. Бобруйск ул. Орджоникидзе, 1 )",
        "456odkjf93jug": "Лакизо Игорь Викторович ( г. Гомель ул.Подпольщиков 18 )",
        savko: "Савко Александр ( г. Минск ул. Ваупшасова, 10 )",
        vorobei: "Воробей Михаил ( г. Минск ул. Ваупшасова, 10 )",
        ksdkdkdpdpoooo: "Иванов Александр Владимирович ( г. Новополоцк ул. Молодёжная 166А )",
        kjdhfldkf88: "Гончаров Андрей ( г. Витебск пр-т Строителей д. 12 к. 1 )",
        volodko: "Верниковский Станислав ( г. Минск ул. Володько, 9 )",
        "grodno-skut": "Шкут Денис ( г. Гродно ул. Горького, 63 )",
        iyuoiglhojpkl99: "Тофоров Павел Васильевич( г. Новополоцк ул. Молодёжная 166А )",
        sdgllkbhjs: "Шумский Юрий Михайлович (г. Могилев ул. Сурганова 13,а )",
        hdovnbsoifgv89: "Муха Андрей ( г. Брест ул. б-р Космонавтов 66 )",
        lkjijoju77: "Корсак Александр ( г. Полоцк ул. Строительная, 19 )",
        fghj77jgggjjjfg: "Черноусов Владислав Юрьевич ( г. Гродно ул. Горького, 63 )",
        kljhjjjjjj7u7uj: "Семенцов Дмитрий Михайлович ( г. Бобруйск ул. Орджоникидзе, 1 )",
        kshfhfhfhhhhooy7: "Патиюк Дмитрий Геннадьевич ( г. Минск ул. Машино-лей, 9А к.1 )",
        kjklhjkl3333: "Жук Артём Александрович ( г. Минск ул. Бельского, 14 )",
        golovkp9isd: "Головко Иван Андреевич ( г. Минск ул. Машино-лей, 9А к.1 )",
        ukjhklledff: "Валуй Сергей ( г. Минск ул. Машино-лей, 9А к.1 )",
        ksjdd9990090876: "Рябцев Вячеслав ( г. Минск ул. Бельского, 14 )",
        vasilev: "Васильев Евгений Валерьевич ( г. Витебск пр-т Строителей д. 12 к. 1 )",
        mjfjgdmjhgt779: "Трояновский Никита ( г. Гомель ул. Б. Хмельницкого, 59 )",
        goml23: "Пилявский Вадим Николаевич ( г. Гомель ул.Подпольщиков 18 )",
        jgfidl8: "Козлов Владислав Викторович ( г. Гомель ул. Б. Хмельницкого, 59 )",
        hanev: "Ханевич Дмитрий( г. Новополоцк ул. Молодёжная 166А )",
        "9yhkjh": "Заболотнёв Дмитрий Анатольевич ( г. Брест ул. б-р Космонавтов 66 )",
        korchunov: "Коршунов Антон Николаевич ( г. Могилев ул. Сурганова 13,а )",
        kjdhlgjuk2: "Середа Дмитрий ( г. Барановичи ул. Комсомольская, 17 )",
        baranki876: "Лешик Виталий Сергеевич ( г. Барановичи ул. Комсомольская, 17 )",
        jdnfbk88: "Дедюля Павел Леонидович ( г. Бобруйск ул. Орджоникидзе, 1 )",
        dflkhjsdfoasdfjhu: "Гурский Александр Игоревич ( г. Бобруйск ул. Орджоникидзе, 1 )",
        bobru23123: "Федотов Павел Александрович ( г. Бобруйск ул. Орджоникидзе, 1 )",
        "5eghdfhdfh5": "Банкевич Вадим Вячеславович ( г. Барановичи ул. Комсомольская, 17 )",
        "andrushchenko-taras-sergeevich": "Андрущенко Тарас Сергеевич ( г. Барановичи ул. Комсомольская, 17 )",
        "pomazenko-aleksandr-sergeevich": "Помазенко Александр Сергеевич ( г. Минск ул. Машино-лей, 9А к.1 )",
        "9p8oyihjg": "Замыслова Инга",
        ishdjsdkj34: "ул. Ваупшасова 10	",
        "salyt-magazin": "Ваупшасова",
        "in-reserve": "Отмена",
        bonusami: "Бонусами",
        "onliner-autoenergy-by": "1. onliner *Energy Centre",
        Gomelsklad: "Гомель, Ефремовский склад",
        Gomel: "Гомель, Ефремовский рынок",
        "ukomplektovan-1": "Укомплектован",
        "beznal-oplata": "2. Терминал (любые карты)",
        sto32: "СТО",
        nedozvonilas: "Не дозвонилась",
        jy7t879y: "Шунейко Алесь Юрьевич ( г. Минск ул. Володько, 9 )",
        "volodko-magazin": "Володько 9",
        "ne-otgruzhen-eshche": "не отгружен еще",
        "servisnyi-tsentr": "Сервисный центр",
        "1-brak-servisnyi-tsentr": "1. БРАК - Сервисный центр",
        "masshinostroiteley-magazin": "Машиностроителей 9а",
        "sklad-mashinostroiteley": "Машиностроителей 9А",
        "loyalty_level": "По уровню",
        none: "Без скидки",
        returned: "Возврат",
        "prodan-1": "Продан (контроль)",
        "by-post": "8. ЕРИП или рассрочка банк - не используем",
        "mogilev-magaz": "Могилев",
        mogilevsklad: "Могилёв склад",
        "sklad-volodko": "Володько 9",
        krasavchikprodavec: "5. Продавец красавчик (вилкой проверил+дисконт+гарантия)",
        "andrei-iodo": 'Йодо Андрей'
      },
      statusesOrder: [
        { value: "new", label: "Новый", color: "rgba(254,165,48,1)", class: "new" },
        { value: "approval", label: "Согласование", color: "rgba(254,165,48,0.2)", class: "approval" },
        { value: "assembling", label: "Сборка", color: "rgba(101,40,215,0.1)", class: "assembling" },
        { value: "delivery", label: "Доставка", color: "rgba(0,94,235,0.13)", class: "delivery" },
        { value: "custom-17", label: "Специальный", color: "rgba(175,185,195,1)", class: "custom-status-color-17" },
        { value: "complete", label: "Завершено", color: "rgba(34,201,147,0.15)", class: "complete" },
        { value: "cancel", label: "Отмена", color: "rgba(255,83,83,0.15)", class: "cancel" },
        { value: "custom-3", label: "Дополнительно", color: "rgba(101,40,215,0.1)", class: "custom-status-color-3" },
        { value: "custom-23", label: "Темный", color: "rgba(30,34,72,1)", class: "custom-status-color-23" },
      ],
      
      statusGroupsOrder: [
      {
    group: "new",
    color: "rgba(254,165,48,1)",
    options: [
      { value: "2", label: "Новый", disabled: true, class: "new" },
      { value: "new", label: "Новый", dataData: "new", class: "new" },
      { value: 'propushchennyi-zvonok', label: 'Пропущенный звонок', dataData: "new", class: "new"}
    ],
      },
        {
    group: "approval",
    color: "rgba(254,165,48,0.2)",
    options: [

    { value: "2", label: "Согласование", disabled: true, class: "approval" },
      { value: "vzial-v-rabotu", label: "Взял в работу", class: "approval" },
      { value: "availability-confirmed", label: "Консультация", dataData: "availability-confirmed", class: "approval" },
      { value: "sdilsddkls", label: "Счет отправлен", class: "approval" },
      { value: "lskdjslkklsk", label: "Ожидание оплаты", class: "approval hide" },
      { value: "dffddsdfsdd", label: "Отложено", class: "approval" },
      { value: "offer-analog", label: "СРЕЗАТЬ", class: "approval" },
      { value: "maslosto", label: "Масло, СТО, запчасти, шины (для Леши)", class: "approval hide" },
      { value: "sdlkfsdjfsdfsdf-sdfgsdf-sdf", label: "с магазина (обзвонить менеджеру)", class: "approval hide" },
      { value: "pod-zakaz", label: "---- товар под З А К А З ----", class: "approval" },
      { value: "novyi-beznalnyi-klient", label: "Новый безнальный клиент", class: "approval" }
    ],
  },
  {
    group: "delivery",
    color: "rgba(0,94,235,0.13)",
    options: [
      { value: "4", label: "Доставка", disabled: true, class: "delivery" },
      { value: "send-to-delivery", label: "Передан в доставку", dataData: "send-to-delivery", class: "delivery" },
      { value: "redirect", label: "Доставка курьером", class: "delivery  hide" },
      { value: "fdjkdfkljd", label: "Доставка транспортной компанией", class: "delivery  hide" },
      { value: "dskjdslksd", label: "Самовывоз", class: "delivery" },
      { value: "zakaz-dostavlen-kur", label: "Заказ доставлен курьером", class: "delivery  hide" },
      { value: "zakaz-magaz", label: "заказ из магазина", class: "delivery  hide" },
      
    ],
  },
  {
    group: "cancel",
    color: "rgba(255,83,83,0.15)", // Примерный цвет для отмененных заказов
    options: [
      { value: "cancel-other", label: "Отмена", disabled: true, class: "cancel" },
      { value: "cancel-other", label: "Отменен", class: "cancel" },
      { value: "otmena-dubl", label: "Отмена дубль", class: "cancel" },
      { value: "otmenaskomentom", label: "Масло, СТО, запчасти, шины (ОТМЕНА с комментом)", class: "cancel" },
      { value: "khkhhjgsdlgtij6", label: "Отмена сдача акб, диагностика", class: "cancel" },
      { value: "otmena-s-necelevoi", label: "Нецелевой (гарантия, неверный номер...) Обязю указывю причину", class: "cancel" },
      { value: "otmena-magas-mesto-man", label: "Отмена с магазина (обзвонить менеджеру)", class: "cancel"},
      { value: "otmena-kupil-u-dr-mened", label: "Отмена купил у другого менеджера", class: "cancel"},
      { value: "otmena-s-otgruzkoi-kureru", label: "3. Отмена с отгрузкой курьеру", class: "cancel"},
      { value: "otmena-vozim-by", label: "4. Отмена с отгрузкой транспортной компании", class: "cancel"},
      { value: "povregden-tovar-piidostavke", label: "10. Поврежден товар при доставке", class: "cancel"},
      { value: "delyvery-did-not-suit", label: "2. Отмена с доставкой Минск", class: "cancel"},
      { value: "otmenasdostavk", label: "2а. Отмена с доставкой ТС", class: "cancel"},
      { value: "prodaza-chastichnaya-sostoyalas", label: "11. Частичная продажа с возвратом на СКЛАД", class: "cancel"},
      { value: "obmen-s-doplatiu", label: "13. Обмен товара с доплатой", class: "cancel"},
      { value: "kiuhhjsdsdkkkkkkk12", label: "15. Отмена с доставкой Минск, неверный подбор, итого купил", class: "cancel"},
      { value: "klkhdshjlsd88sdfsdf898", label: "15b. Отмена с доставкой Минск, неверный подбор, итого НЕ купил", class: "cancel"},
      { value: "kdjfffffff8hjf", label: "15a. Отмена с доставкой Минск, дело не в акб, итого НЕ купил", class: "cancel"},
      { value: "khkhhjgsdlgtij6", label: "16. Отмена сдача акб, диагностика", class: "cancel"},
      { value: "send-to-assembling", label: "5. Отмена отгрузка с КАРВАТА - возврат на магазин розничный", class: "cancel"},
      { value: "otmenasdoskdfjdkfj", label: "2b. Отмена с доставкой ТК товар на складе", class: "cancel"},
      { value: "otmena-sotgruz-kupil", label: "3а. Отмена с отгрузкой курьеру (Итого КУПИЛ)", class: "cancel"},
      { value: "otmena-nashel-konkurentov", label: "7. Отмена нашёл намного дешевле у конкурентов", class: "cancel"},
      { value: "otmenasvozvratomvmagazin", label: "12. Отмена с возвратом в этот же магазин (собственная продажа магазина)", class: "cancel"},
      { value: "5blsdfhoisdhflkdshf", label: "5b. Отмена заказ из магазина", class: "cancel"},
      { value: "otmena-s-necelevoi", label: "17. Нецелевой (гарантия, неверный номер...) Обязю указывю причину", class: "cancel"},
      { value: "kldjfdfdfsdfsdfdfffffffffffffff", label: "Контроль Нецелевой (гарантия, неверный номер...)", class: "cancel"},
    ],
  },
  {
    group: "complete",
    color: "rgba(34,201,147,0.15)", // Примерный цвет для комплектации заказов
    options: [
      
      { value: "5asjkdhgfilu333", label: "5а. Собственная продажа магазина", class: "complete hide" },
      {value: "dsfssffsds", label: "5. Заказ забран", class: "complete hide"},
      {value: "kfhdlfhgkfldfofuglfdlidfhgfdgjlfklghldfk", label: "Контроль Отмена с доставкой Минск", class: "complete hide"},
      {value: "kontrolhgcfxhg", label: "1. Контроль", class: "complete hide"},
      {value: "15k-usljsd-sl", label: "15.КОНТРОЛЬ Отмена с дост Минск, дело не в акб,НЕ купил", class: "complete hide"},
      {value: "vyopilnen-svozvratomvmagaztovara", label: "3. Выполнен отмена отгрузка с КАРВАТА - возврат на САЛЮТЫ", class: "complete hide"},
      {value: "12kontrol-obmen", label: "12. Контроль обмен товара с доплатой", class: "complete hide"},
      {value: "kontrol-vozvrat-na-sklad", label: "11. Контроль частичная продажа с возвратом на СКЛАД", class: "complete hide"},
      {value: "jkjsdlflsdhfgdld", label: "Контроль Конверт", class: "complete hide"},
      {value: "876h-hk-kjhkj", label: "15. КОНТРОЛЬ Отмена с дост Минск, нев под,купил", class: "complete hide"},
      {value: "5asjkdhgfilu333", label: "5а. Собственная продажа магазина", class: "complete hide"},
      {value: "kontrol-vozvratr-magazin", label: "1. Контроль отмена отгрузка с КАРВАТА - возврат на САЛЮТЫ (на любой наш магазин)", class: "complete hide"},
      {value: "6kontrol-otmena-ddubl", label: "6a.Контроль отмена дубль", class: "complete hide"},
      {value: "otmena-sdacha-akb", label: "6b. Контроль отмена диагностика, сдача акб", class: "complete hide"},
      {value: "7kontrol-otmena", label: "7а Контроль ОТМЕНА", class: "complete hide"},
      {value: "kontrol-maslo-sto", label: "КОНТРОЛЬ Масло, СТО, запчасти, шины", class: "complete hide"},
      {value: "kontrol-kupil-u-ddrugogo", label: "Контроль купил у другого менеджера", class: "complete hide"},
      {value: "sobstvenn55proda", label: "Собственная продажа ВЫПОЛНЕНО", class: "complete hide"},
      {value: "samovyvos-zabra-vypol", label: "Самовывоз забран ВЫПОЛНЕНО", class: "complete hide"},
    ],
  },
  {
    group: "dflkdslskl",
    color: "#afb9c3", // Примерный цвет для комплектации заказов
    options: [
      
      {value: "dsfssffsds", label: "5. Заказ забран", class: "complete hide"},
      {value: "1-zakaz-kurerom-dostavlen-dengi-i-bu-sdany", label: "2. заказ курьером доставлен (деньги и бу сданы)!!!!!!" , class: "complete hide"},
      {value: "zamena0po0braku", label: "6. Замена по браку", class:"complete hide"},
      { value: "fdkjsdkjdsklkl1", label: "3. Доставлен ТС", class: "complete hide"},
      { value: "kushddflsidudhy", label: "Доставлен ТС + БУ забрали", class: "complete hide"},
      { value: "nelvvhs47ujgt", label: "Доставлен ТС + БУ НЕ забрали !", class: "complete hide"},
      { value: "povtornaya098", label: "Повторная доставка состоялась", class: "complete hide"},
      { value: "zaradka-akb-uspeshno4", label: "Зарядка АКБ (неудачная)", class: "complete hide"},
      { value: "zaradka-akb-uspeshno", label: "Зарядка АКБ (успешно)", class: "complete hide"},
      { value: "ofis-prinyal-dengi", label: "1. Офис принял деньги", class: "complete hide"},
      { value: "korrektirovka-zakaza", label: "4. корректировка заказа", class: "complete hide"},
    ],
  },
  {
    group: "assembling",
    color: "rgba(101, 40, 215, .1)", // Примерный цвет для комплектации заказов
    options: [
      
      { value: "assembling", label: "1. Комплектуется склад Карвата (Курьер 1)", class: "complete hide" },
      { value: "assembling-complete", label: "2. Комплектуется склад Карвата (Курьер 2)", class: "complete hide"},
      { value: "3-komplektuetsya-sklad-sharangovicha-kurer-1", 'label': '3. Комплектуется склад Карвата (Курьер 3)', class: 'complete hide'},
      { value: "4-komplektuetsya-sklad-sharangovicha-kurer-2", 'label': '4. Комплектуется склад Карвата (Курьер 4)', class: 'complete hide'},
      { value: "ktuetsya-sklad-sharangovicha-kur234234ggg", 'label': '5. Комплектуется склад Карвата (Курьер 5)', class: 'complete hide'},
      { value: "jdhfjfhjdhfjdhfdfhhhhhhhhhhhhh", 'label': '6. Комплектуется склад Карвата (Курьер 6)', class: 'complete hide'},
      { value: "7-komplektuetsia-sklad-karvata-kurer-7", 'label': '7. Комплектуется склад Карвата (Курьер 7)', class: 'complete hide'},
      { value: "8-komplektuetsia-sklad-karvata-kurer-8", 'label': '8 Комплектуется склад Карвата (Курьер 8)', class: 'complete hide'},
      { value: "9-komplektuetsia-sklad-karvata-kurer-9", 'label': '9 Комплектуется склад Карвата (Курьер 9)', class: 'complete hide'},
      { value: "10-komplektuetsia-sklad-karvata-kurer-10", 'label': '10. Комплектуется склад Карвата (Курьер 10)', class: 'complete hide'},
      
    ],
  },
  {
    group: "brak12",
    color: "rgba(101,40,215,0.1)",
    options: [
      
      { value : "1-priniat-na-proverku-sostavleny-vse-bumagi-postavil-na-zariadku", label: "1. Принят на проверку (составлены все бумаги, находится на диагностике у меня)", class:"complete"},
      { value : "2a-akb-zariadilsia-klienta-uvedomil-zhdu-ego-vizita", label: "2а. АКБ зарядился, клиента уведомил, жду его визита (Брака нет)", class:"complete"},
      { value : "2b-ne-zariadilsia-klienta-uvedomil-zhdu-ego-vizita-sniat-s-garantii", label: "2б. НЕ зарядился, клиента уведомил, жду его визита - (СНЯТ с гарантии)", class:"complete"},
      { value : "3-1-s-karvata-peredali-na-mashinostroitelei-servis", label: "3/1 с Карвата передали на Машиностроителей сервис", class:"complete"},
      { value : "3-1-s-karvata-peredali-postavshchiku-importioru-ne-nasha-akb", label: "3/1 с Карвата передали поставщику (импортёру), не наша АКБ", class:"complete"},
      { value : "3-2-s-mashinostroitelei-servis-peredali-na-karvata", label: "3/2 с Машиностроителей сервис  передали на Карвата", class:"complete"},
      { value : "4-otkaz-net-braka-budet-vozvrat-klientu", label: "4. АКБ остаётся на складе у нас, клиенту или деньги или новый", class:"complete"},
      { value : "0-vopros-uregulirovan-klient-bolshe-ne-bespokoit", label: "0. Вопрос урегулирован, клиент больше не беспокоит", class:"complete"},
      { value : "0-neobkhodim-otvet-na-pretenziiu", label: "0. Необходим ответ на претензию", class:"complete"},
      { value : "0-otvet-otpravlen-potrebiteliu", label: "0. Ответ отправлен потребителю", class:"complete"},
      { value : "6-postavshchik-vernul-nam-novyi-akb-vmesto-braka", label: "6. Поставщик вернул нам новый АКБ вместо брака (БРАК остался у поставщика)", class:"complete"},
      { value : "3-2-ot-postavshchika-peredali-na-karvata", label: "3/2 от поставщика передали на Карвата", class:"complete"},
      { value : "4-brak-podtverzhdion-soglasovyvaetsia-zamena-klienta-opovestil", label: "4. Необходимо вернуть клиенту при довозе - или согласовывается замена, клиента оповестил.", class:"complete"},
      { value : "2g-ne-zariadilsia-klienta-uvedomil-chto-peredaiu-na-minsk-vozmozhno-brak", label: "2г. НЕ зарядился, клиента уведомил что возможно БРАК ( передаю на Минск или жду подтверждения что БРАК)", class:"complete"},
      { value : "5-vydan-pokupateliu-novyi-akb-dokumenty-podpisany-vopros-zakryt", label: "5г. Выдан покупателю НОВЫЙ АКБ вместо его БРАКА ( Вопрос закрыт)", class:"complete"},
      { value : "5-vydan-obratno-ego-zhe-akb-ne-zariadilsia-sniat-s-garantii", label: "5б. Выдан обратно его же АКБ, НЕ зарядился - (СНЯТ с гарантии)", class:"complete"},
      { value : "ili-dengi-dokumenty-podpisany", label: "5д. Выданы покупателю ДЕНЬГИ вместо его бракованного АКБ ( Вопрос закрыт)", class:"complete"},
      { value : "2-vopros-uregulirovan-v-magazine-vozvrashchion-klientu-zariazhennym", label: "5а. Отдан клиенту его же, АКБ ИСПРАВЕН  (возвращён клиенту после подзарядки)", class:"complete"},
   
    ]
  },
  {
    group: "sto12f",
    color: "rgba(30,34,72,1)",
    options: [
      { value: "sto-prodazaza", label: "1) Необходим подбор и продажа запчастей", class: ""},
      { value: "stoffnksajn12212", label: "2) Авто ожидает ремонта (ждет зч/очередь)", class:""},
      { value: "avto-v-remonte-v-tsekhu", label: "3) Авто в ремонте, в цеху", class: ""},
      { value: "gotov-k-vydache", label: "4) Готово к выдаче авто", class: ""},
      { value: "5-avto-vydan-klientu", label: "5) Авто выдан клиенту", class: ""},
      { value: "stowfifdk2j", label:"6) Ничего не нужно, не поможем (указываем причину)", class:""},
      { value: "prokonsultirovan-perezvonit-pozzhe", label:"1) Проконсультирован, пнуть клиента позже", class:""},
      { value: "neobkhodimo-perezvonit-klientu-zapchasti-tseny-perechen-rabot-sto", label:"1) Необходимо перезвонить клиенту: запчасти, цены, перечень работ (СТО)", class:""},
    ]
  },
  
      ],

    };
  },
  mounted(){
    this.fetchManagers();

  },
  computed: {
    statusChanges() {
      return this.historyData.filter(item => item.field === 'status');
    },
    orderChanges() {
      return this.historyData;
    },
      groupedOrderChanges() {
    const map = {};

    for (const change of this.orderChanges) {
      const key = change.changeTime;
      if (!map[key]) {
        map[key] = {
          time: key,
          changes: []
        };
      }
      map[key].changes.push(change);
    }

    return Object.values(map);
  },




  },
  watch: {
    isVisible(newVal) {
      if (newVal) {
        this.fetchOrderHistory();
      }
    },
    
  },
  methods: {

    getColorByCode(code) {
      if(code && code.code){
        for (const group of this.statusGroupsOrder) {
                if (group.options) {
                  for (const option of group.options) {
                    if (option.value === code.code) {
                      return group.color;
                    }
                  }
                }
              }
      }
      for (const group of this.statusGroupsOrder) {
        if (group.options) {
          for (const option of group.options) {
            if (option.value === code) {
              return group.color;
            }
          }
        }
      }
      return null; // цвет по умолчанию, если не нашли
    },
getGroupByCode(code) {
  const value = code && code.code ? code.code : code;

  if (!value) return null;

  for (const group of this.statusGroupsOrder) {
    if (group.options) {
      for (const option of group.options) {
        if (option.value === value) {
          return group.group;
        }
      }
    }
  }

  return null;
},

    fetchManagers() {
      axios.get(ORDERS_API_BASE + '/allusers.php')
        .then(response => {
            this.allmanagers = response.data; // массив менеджеров
        })
        .catch(error => {
            console.error('Ошибка при получении менеджеров:', error);
        });
    },



    curManager(id){
      const manager = this.allmanagers.find(manager => manager.value === id);
      return manager ? manager.label : id;
    },

    async fetchOrderHistory() {
  this.loading = true;
  this.historyData = [];
  let sinceId = 0;
  let keepFetching = true;

  try {
    while (keepFetching) {
      const response = await axios.post(ORDERS_API_BASE + '/ordersHistory.php', {
        orderId: this.orderId,
        filter: { sinceId }
      });

      if (!response.data.success) {
        alert('Ошибка при получении истории: ' + response.data.message);
        break;
      }

      const batch = response.data.history;
      if (!batch.length) break;

      this.historyData.push(...this.prepareData(batch));

      // Обновляем sinceId для следующего запроса
      const lastEntry = batch[batch.length - 1];
      sinceId = lastEntry.id;

      // Проверка на pagination count (если меньше лимита — всё, закончили)
      const paginCount = response.data.pagination.totalPageCount;
      if (paginCount < 2) {
        keepFetching = false;
      }
    }

    // Добавим названия продуктов
    const addTitlesToHistory = async (valueKey) => {
      const entries = this.historyData.filter(
        entry => entry[valueKey] && typeof entry[valueKey] === 'object' && 'offer' in entry[valueKey]
      );

      await Promise.all(entries.map(async entry => {
        const prodId = entry[valueKey].offer.externalId;
        const prodTitle = await this.fetchProductTitle(prodId);
        entry[valueKey].offer.nameProd = prodTitle;
      }));

      console.log(`добавил заголовки в this.historyData → ${valueKey}`);
    };

    await addTitlesToHistory('oldValue');
    await addTitlesToHistory('newValue');

    this.historyData.reverse();
    this.setHeight();

  } catch (error) {
    console.error('Ошибка при получении истории:', error);
    alert('Произошла ошибка при получении истории.');
  } finally {
    this.loading = false;
  }
},
    async fetchProductTitle(prodId) {
      try {
        const response = await axios.get(`${ORDERS_API_BASE}/productimage.php?id=${prodId}`);
        return response.data.name;
      } catch (error) {
        console.error(`Не удалось загрузить заголовок для товара ${prodId}:`, error);
        return '';
      }
    },
    setHeight() {
      setTimeout(() => {

        this.$nextTick(() => {
        const tabl = this.$refs.tabl;
        if(tabl) {
          const scrollHeight = tabl.scrollHeight;

          const modalContent = this.$refs.modalContent;
          if(modalContent) {
            modalContent.style.height = `${scrollHeight}px`; 
            modalContent.style.maxHeight = `${scrollHeight}px`; 
          }
        }
        });

        }, 100);
    },
    prepareData(history) {
      return history.map(item => {
        const changedBy = item.source === 'user' ? (item.user && item.user.id ? item.user.id : 'Неизвестно') : 'API';
        return {
          id: item.id,
          field: item.field,
          newValue: item.newValue,
          oldValue: item.oldValue,
          changeTime: new Date(item.createdAt).toLocaleString(),
          changedBy,
          statusGroup: item.order && item.order.status ? item.order.status : 'N/A',
          comment: item.newValue && item.newValue.comment ? item.newValue.comment : ''
        };
      });
    },
    formatName(value) {
  const dictionary = {
    additional_phone: 'Доп. телефон',
    custom_prodavec: 'Продавец',
    custom_komentariimenedgera: 'Комментарии менеджера',
    custom_sssylkaaaaasssyyylka: 'Ссылка на подбор',
    custom_slksdkk2j3iu3n: 'Ёмкость аккумулятора в зачет',
    custom_sf_date: 'Счет-фактура от',
    custom_redaktor: 'Кто редактировал',
    delivery_cost: 'Стоимость доставки',
    delivery_date: 'Дата доставки',
    delivery_net_cost: 'Себестоимость доставки',
    delivery_time: 'Время доставки',
    delivery_type: 'Тип доставки',
    discount: 'Разовая скидка',
    discount_percent: 'Разовая скидка %',
    email: 'Email',
    first_name: 'Имя',
    height: 'Высота',
    last_name: 'Фамилия',
    length: 'Длина',
    manager_comment: 'Комментарий оператора',
    order_method: 'Способ офомления заказа',
    patronymic: 'Отчество',
    phone: 'Телефон',
    manager: 'Менеджер',
    'order_product.base_purchase_price': 'Закупочная стоимость',
    shipment_date: 'Дата отгрузки',
    weight: 'Вес',
    custom_moyskladexternalid: 'Идентификатор в Мой склад',
    width: 'Ширина',
    "delivery_address.block": 'Подъезд',
    "delivery_address.building": 'Дом',
    "delivery_address.city": 'Город',
    "delivery_address.flat": 'Квартира',
    "delivery_address.floor": 'Этаж',
    "delivery_address.housing": 'Корпус',
    "delivery_address.region": 'Регион',
    "delivery_address.street": 'Улица',
    custom_dfgfdddf: 'Сумма за аккумулятор в зачет',
    custom_model_podborts: 'Модель ТС',
    custom_komisi: 'Комиссия',
    custom_marssh: 'Маршрутный лист курьер',
    custom_sf_num: 'Корректировка заказа',
    custom_garantia: 'Пометка СТО',
    custom_kdhfkjh34g: 'Район и Сельсовет',
    custom_toplivo_vid: 'Вид топлива',
    custom_emaildfhdfjh: 'email2',
    custom_godts_podbor: 'Год ТС',
    custom_lkjdhgdhg768: 'Номер реестра',
    custom_marka_podbor: 'марка ТС',
    custom_tip_ts_podbor: 'тип ТС',
    custom_fglhkjpjsdb888: 'Сквозная аналитика',
    custom_jsdhjlkshdlk99: 'История страниц',
    custom_vision_site: 'Посещённые страницы',
    custom_nazvats_podbor: 'Название ТС',
    custom_ozon_order_number: 'Озон код',
    custom_tiprorpusa_ts_podbor: 'Тип корпуса в подборе ТС',
    customer_comment: 'Комментарии клиента',
    "delivery_address.index": 'Почтовый индекс',
    "delivery_address.notes": 'Дополнительная информация',
    custom_podbor_plox_sovsem: 'Неверный подбор на сайте',
    custom_dsksajklsal: 'Есть скидочная карта',
    custom_dfhgodsf8g7: 'Бонус',
    "integration_delivery_data.courier": 'Курьер',
    custom_sto: 'диагностика',
    custom_raschet_kurera1: 'акб сдан',
    source: 'Источник',
    order_type: 'Тип заказа',
    "contragent.contragent_type": 'Тип контрагента',
    expired: 'Заказ просрочен',
    order_product: 'Добавлен товар',
    "contragent.bank": 'Банк',
    "contragent.bank_account": 'Рачетный счет',
    "contragent.bank_address": 'Адрес банка',
    "contragent.i_n_n": 'ИНН',
    "contragent.legal_address": 'Адрес регистрации',
    "contragent.legal_name": 'Полное наименование',
    "order_product.price_type": 'Тип цены',
    "order_product.status": 'Статус товара',
    "delivery_address.metro": 'Метро',
    custom_hour: 'Время статуса',
    shipped: 'Отгружен',
    shipment_store: 'Склад отгрузки',
    site: 'Магазин',
    custom_podbor_trigger: 'Возможно неверный подбор',
    "order_product.bonuses_charge": 'Списано бонусов за товар',
    "order_product.summ": 'Стоимость товара',
    "order_product.discount": 'Денежная скидка',
    "payment_status": 'Статус платежа',
    "full_paid_at": 'Дата полной оплаты',
    "custom_ocenka_manageru1": 'Оценка менеджеру',
    "custom_obzvon_klienta": 'Обзвон клиента',
    "custom_datazakazaobrabotki": 'Дата обработки заказа',
    "custom_data_soglasovaniia1": 'Дата согласования',
    "custom_vgvgvgv": '№ ВГ',
    "custom_bonus_prodavec": "Бонус доп услуги",
    "custom_predoplata_beznalichnymi_spravochnik": "Предоплата безналичными (справочник)",
    "custom_vznos": "Сумма первого взноса",
    "payment_type": "Тип платежа",
    "payment_detail": "Детали оплаты",
    "order_product.initial_price": 'Цена',
    "custom_sklad_api": 'Склад api',
    "custom_magazin_api": 'Магазин',
    "custom_ocenkaprodavcu": 'Оценка продавцу',
    "custom_dfgfdddfnew": "Сумма за аккумулятор в зачет",
    "custom_slksdkk2j3iu3nnew": "Ёмкость аккумулятора в зачет",
    "custom_kasssas": "Касса",
    "salyt-magazin": "Ваупшасова",
    "order_product.discount_percent": "Процентная скидка",
    "privilege_type": "Тип привилегии",
    "loyalty_level": "Уровень",
    "loyalty_account": "Участие в программе лояльности",
    "integration_delivery_data.locked": "Не синхронизировать со службой доставки",
    "custom_sozdan_cherez_managera": "Создан через манагера",
    "order_product.quantity": "Количество",
    "custom_zp_za_zakaz": "ЗП (старое)",
    "custom_lkhjdfg777jf": "Бонус Магазин (архив)",
    "custom_oplacheno_bonusami": "Оплачено бонусами",
    "custom_bonus_client": 'Бонусы начислены',
    customer: 'Клиент',
    contact: 'Контактное лицо',
    "custom_data_izmeneniia": 'Дата изменения',
    status: 'Изменение статуса',
    'custom_manager': 'Менеджер',
    'vitalii-nikolaenko': 'Виталий Николаенко',
    'custom_mashina_kurera': 'Машина курьера',
    'payments.amount': 'Сумма платежа',
    'payments.paid_at': 'Дата изменения',
    'payments.status': 'Статус платежа',
    'payments': 'Оплата'
  };

  if (value && dictionary[value]) {
    return dictionary[value];
  }
  return value || 'N/A'; // Если значение не найдено, вернуть исходный код
},
formatStatus(value) {
  if (value && value.code) {

    
    // Ищем группу, которая содержит нужный статус
    const group = this.statusGroupsOrder.find(group => 
      group.options.some(option => option.value === value.code)
    );

    // Если группа найдена, ищем нужный статус в её options
    if (group) {
      const option = group.options.find(option => option.value === value.code);
      return option ? option.label : value.code; // Возвращаем label или код
    }
  }
  return value.code; // Возвращаем 'N/A', если ничего не найдено
},


  
    formatOldValue(value) {
      
      if(value === false){
        return 'Нет';
      }

      if (value && value.code) {

        // Ищем группу, которая содержит нужный статус
        const group = this.statusGroupsOrder.find(group => 
          group.options.some(option => option.value === value.code)
        );

        // Если группа найдена, ищем нужный статус в её options
        if (group) {
          const option = group.options.find(option => option.value === value.code);
          return option ? option.label : value.code; // Возвращаем label или код
        }
      }
      
      if(typeof value === 'object' && value !== null && 'offer' in value && typeof value.offer === 'object' && value.offer.nameProd){
          return value.offer.nameProd;
      }
      
     if (value && this.dictionaryOldstat[value]) {
          return this.dictionaryOldstat[value];
      } 

      if (typeof value === 'object' && value !== null && this.dictionaryOldstat[value.code]) {
        const newvals = value.code; 
        return this.dictionaryOldstat[newvals];
      }

      
      else if(value !== null && typeof value === 'object' && 'from' in value && 'to' in value){
        return 'С ' + value.from + ' до ' + value.to;
      }
      else if(value !== null && typeof value === 'object' && 'from' in value){
        return 'С ' + value.from;
      }
      else if(value !== null && typeof value === 'object' && 'to' in value){
        return 'до ' + value.to;
      }
      else if(value !== null && typeof value === 'object' && 'id' in value){
        
        // Функция для поиска лейбла
        const getLabel = (array, id) => {
            const foundItem = array.find(item => item.value === id);
            return foundItem ? foundItem.label : id;
        };

        if (value.id.toString().length <= 3) {
            // Сначала ищем в allmanagers
            const managerLabel = getLabel(this.allmanagers, value.id);
            
            // Если менеджер не найден, ищем в curiers
            if (managerLabel === value.id) {
                const curierLabel = getLabel(this.curiers, value.id);
                return curierLabel; // Возвращаем результат из curiers или value.id, если ничего не найдено
            }
            
            return managerLabel; // Возвращаем найденный лейбл менеджера
        } else {
            return value; // Возвращаем value, если длина id больше 3
        }
       
      }
      else if (value !== null) {
        return value;
      }
          
    },

 

    formatNewValue(value) {

      if(value === false){
        return 'Нет';
      }

      if (value && value.code) {

        // Ищем группу, которая содержит нужный статус
        const group = this.statusGroupsOrder.find(group => 
          group.options.some(option => option.value === value.code)
        );

        // Если группа найдена, ищем нужный статус в её options
        if (group) {
          const option = group.options.find(option => option.value === value.code);
          return option ? option.label : value.code; // Возвращаем label или код
        }
      }


      if(typeof value === 'object' && value !== null && 'offer' in value && typeof value.offer === 'object' && value.offer.nameProd){
          return value.offer.nameProd;
      }

      if (value && this.dictionaryOldstat[value]) {
          return this.dictionaryOldstat[value];
      } 
      if (typeof value === 'object' && value !== null && this.dictionaryOldstat[value.code]) {
        const newvals = value.code; 
        return this.dictionaryOldstat[newvals];
      }
      else if(value !== null && typeof value === 'object' && 'from' in value && 'to' in value){
        return 'С ' + value.from + ' до ' + value.to;
      }
      else if(value !== null && typeof value === 'object' && 'from' in value){
        return 'С ' + value.from;
      }
      else if(value !== null && typeof value === 'object' && 'to' in value){
        return 'до ' + value.to;
      }
      else if(value !== null && typeof value === 'object' && 'id' in value){
        
        // Функция для поиска лейбла
        const getLabel = (array, id) => {
            const foundItem = array.find(item => item.value === id);
            return foundItem ? foundItem.label : id;
        };

        if (value.id.toString().length <= 3) {
            // Сначала ищем в allmanagers
            const managerLabel = getLabel(this.allmanagers, value.id);
            
            // Если менеджер не найден, ищем в curiers
            if (managerLabel === value.id) {
                const curierLabel = getLabel(this.curiers, value.id);
                return curierLabel; // Возвращаем результат из curiers или value.id, если ничего не найдено
            }
            
            return managerLabel; // Возвращаем найденный лейбл менеджера
        } else {
            return value; // Возвращаем value, если длина id больше 3
        }
       
      }
      else if (value !== null) {
        return value;
      }

    },
    closeModal() {
      this.$emit('close');
    },
    setActiveTab(tab) {
      this.activeTab = tab;
      this.setHeight(); 
    }
  }
};
</script>

<style scoped>
.modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}
.modal-overlay {
  position: fixed;
  width: 100%;
  height: 100%;
  background: rgba(45,51,108,.4);
}
.modal .modal-content {
  background: #fff;
  border-radius: 8px;
  color: #1e2248;
  display: flex;
  flex-direction: column;
  margin: auto;
  min-height: 400px;
  position: relative;
  padding: 0;
  width: 880px;
  overflow: hidden;
}
.close-btn {
  position: absolute;
  top: 10px;
  right: 10px;
  border: none;
  background: none;
  font-size: 24px;
  cursor: pointer;
}

.loading {
  text-align: center;
  padding: 20px;
}

.modal .UiTabs-tabs__controls-2RzE {
    border-bottom: 1px solid #dee2e6;
    display: flex;
}
.modal .UiTabs-tabs__control-1-mU.UiTabs-tabs__control_active-2kxM {
    background-color: #f4f6f8;
    color: #0052cc;
}

.modal .UiTabs-tabs__control-1-mU.UiTabs-tabs__control_active-2kxM::before {
    border-bottom: 2px solid transparent;
    bottom: -1px;
    content: "";
    left: 0;
    position: absolute;
    width: 100%;
    transition: border-color .2s linear;
    border-color: #005eeb;
    border-width: 4px;
}

.modal .UiTabs-tabs__control-1-mU {
    font-size: 20px;
    line-height: 1.6;
    margin-right: 0;
    padding: 22px 32px;
    -webkit-tap-highlight-color: transparent;
    align-items: center;
    background: 0 0;
    border: none;
    cursor: pointer;
    display: flex;
    margin: 0 24px 0 0;
    outline: 0;
    position: relative;
    transition: .25s ease;
    white-space: nowrap;
    font-weight: bold;
}

.modal .cell_eOMiF {
    background-color: #f9fafb;
    border-bottom: 1px solid #dee2e6;
    color: #8a96a6;
    padding: 12px;
}
.modal .table_AJsNp {
    border-collapse: collapse;
    border-spacing: 0;
    width: 100%;
}
.modal .table_AJsNp {
  table-layout: fixed;
}
.modal .UiText-text_tiny-1_wc {
    font-size: 12px;
    font-weight: 400;
    line-height: 1.16666667;
    width: 100%;
}
.modal .close-btn {
    bottom: auto !important;
    color: #afb9c3;
    right: 18px;
    top: -18px;
    width: 32px;
    font-size: 32px;
}
.modal .modal-header {
  padding: 0;
}
.modal .table_KrFDw td {
    font-size: 12px;
    font-weight: 400;
    line-height: 1.16666667;
}
.modal .cell_left_eorMY {
    text-align: left;
}
.modal .cell_top_AYyWZ {
  vertical-align: top;
}
.modal .cell_OWup9 {
   border-bottom: 1px solid #dee2e6;
    padding: 16px 12px;
}
.modal .cell_eOMiF:first-child {
  padding-left: 32px;
}



/* Иконки статусов */

.UiTabs-tabs-3VpC span.new {
    background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' fill='%23fff'%3E%3Cpath fill-rule='evenodd' d='M12.5 4h-1a.5.5 0 0 1-.5-.5v-2a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-.5.5zm-6.255 6.334A6 6 0 0 1 12 6a6 6 0 0 1 3.2 11.07 1.48 1.48 0 0 0-.7 1.27v.16a.5.5 0 0 1-.5.5h-4a.5.5 0 0 1-.5-.5v-.16a1.5 1.5 0 0 0-.7-1.27 6 6 0 0 1-2.555-6.736zM8 12a4 4 0 1 0 8 0 4 4 0 0 0-8 0zm2 9.59a1 1 0 0 0 .29.7l.42.42a1 1 0 0 0 .7.29h1.18a1 1 0 0 0 .7-.29l.42-.42a1 1 0 0 0 .29-.7V21h-4v.59zM20.13 4.58l-.71-.71a.48.48 0 0 0-.7 0L17.3 5.28a.51.51 0 0 0 0 .71l.7.71a.51.51 0 0 0 .71 0l1.41-1.42a.48.48 0 0 0 .01-.7zM5.28 3.87 6.7 5.28a.51.51 0 0 1 0 .72l-.7.7a.51.51 0 0 1-.72 0L3.87 5.28a.48.48 0 0 1 0-.7l.71-.71a.48.48 0 0 1 .7 0zM22.5 11h-2a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h2a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5zm-21 0h2a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5z' clip-rule='evenodd'/%3E%3C/svg%3E");
}


.UiTabs-tabs-3VpC span.delivery {
    background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' fill='%230052CC'%3E%3Cpath fill-rule='evenodd' d='M3.169 2.445a1 1 0 0 1 1.386-.277l3 2A1 1 0 0 1 8.001 5v11.17A3.008 3.008 0 0 1 9.83 18H18a1 1 0 1 1 0 2H9.83A3.001 3.001 0 1 1 6 16.17V5.536L3.447 3.832a1 1 0 0 1-.277-1.387zM7 18h-.01a1 1 0 1 0 .02 0H7zM9 7a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2h-8a2 2 0 0 1-2-2V7zm4 0h-2v8h8V7h-2v3h-4V7z' clip-rule='evenodd'/%3E%3C/svg%3E");
}

.UiTabs-tabs-3VpC span.complete {
    background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' fill='%2319976E'%3E%3Cpath fill-rule='evenodd' d='M12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10A10 10 0 0 0 12 2zm0 18a8 8 0 1 1 0-16 8 8 0 0 1 0 16zm3.12-11.51a.5.5 0 0 1 .7 0l.5.53a.5.5 0 0 1 0 .71l-5.62 5.62a.48.48 0 0 1-.7 0l-2.35-2.37a.5.5 0 0 1 0-.71l.53-.53a.48.48 0 0 1 .7 0l1.5 1.49 4.74-4.74z' clip-rule='evenodd'/%3E%3C/svg%3E");
}

.UiTabs-tabs-3VpC span.assembling {
    background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' fill='%236528D7'%3E%3Cpath fill-rule='evenodd' d='M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12a10 10 0 0 0 10 10zm0-18a8 8 0 1 1 0 16 8 8 0 0 1 0-16zm-.19 14a.77.77 0 0 1-.53-.22l-3.13-3.13a.5.5 0 0 1 0-.71l.71-.71a.49.49 0 0 1 .7 0L11 14.67V6.5a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v8.17l1.44-1.45a.5.5 0 0 1 .71 0l.7.71a.5.5 0 0 1 0 .71l-3.13 3.14a.75.75 0 0 1-.53.22h-.38z' clip-rule='evenodd'/%3E%3C/svg%3E");
}

.UiTabs-tabs-3VpC span.approval {
    background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' fill='%23E18001'%3E%3Cpath fill-rule='evenodd' d='M18 2a4 4 0 0 1 4 4v8a4 4 0 0 1-4 4H8a3 3 0 0 0-2.15.85l-3 3a.49.49 0 0 1-.35.15.5.5 0 0 1-.5-.5V6a4 4 0 0 1 4-4h12zM8 16h10a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2v11.88l.46-.42A5 5 0 0 1 8 16zm-1.5-3h7a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-7a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5zm11-4h-11a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5h11a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5z' clip-rule='evenodd'/%3E%3C/svg%3E");
}

.UiTabs-tabs-3VpC span.cancel {
    background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' fill='%23DD4040'%3E%3Cpath fill-rule='evenodd' d='M12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10A10 10 0 0 0 12 2zm0 18a8 8 0 1 1 0-16 8 8 0 0 1 0 16zm2.56-11.09.53.53a.48.48 0 0 1 0 .7L13.24 12l1.85 1.86a.48.48 0 0 1 0 .7l-.53.53a.48.48 0 0 1-.7 0L12 13.24l-1.86 1.85a.48.48 0 0 1-.7 0l-.53-.53a.48.48 0 0 1 0-.7L10.76 12l-1.85-1.86a.48.48 0 0 1 0-.7l.53-.53a.48.48 0 0 1 .7 0L12 10.76l1.86-1.85a.48.48 0 0 1 .7 0z' clip-rule='evenodd'/%3E%3C/svg%3E");
}

.UiTabs-tabs-3VpC span.custom-status-color-17 {
    background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' fill='%23fff'%3E%3Cpath fill-rule='evenodd' d='M16.004 8A4 4 0 1 1 8 7.998 4 4 0 0 1 16.004 8Zm-2 0a2 2 0 1 0-4.001 0 2 2 0 0 0 4 0Zm5.892 10.55-1.89-3.89A3.001 3.001 0 0 0 15.263 13H8.742a3.001 3.001 0 0 0-2.691 1.66L4.11 18.55A1 1 0 0 0 5 20h14.006a1 1 0 0 0 .89-1.45Zm-12.055-3L6.621 18h10.764l-1.22-2.45a1 1 0 0 0-.9-.55H8.741a1 1 0 0 0-.9.55Z' clip-rule='evenodd'/%3E%3C/svg%3E");
}


.UiTabs-tabs-3VpC span.dflkdslskl {
    background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' fill='%23fff'%3E%3Cpath fill-rule='evenodd' d='M16.004 8A4 4 0 1 1 8 7.998 4 4 0 0 1 16.004 8Zm-2 0a2 2 0 1 0-4.001 0 2 2 0 0 0 4 0Zm5.892 10.55-1.89-3.89A3.001 3.001 0 0 0 15.263 13H8.742a3.001 3.001 0 0 0-2.691 1.66L4.11 18.55A1 1 0 0 0 5 20h14.006a1 1 0 0 0 .89-1.45Zm-12.055-3L6.621 18h10.764l-1.22-2.45a1 1 0 0 0-.9-.55H8.741a1 1 0 0 0-.9.55Z' clip-rule='evenodd'/%3E%3C/svg%3E");
}


.UiTabs-tabs-3VpC span.sto12f  {
    background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' fill='%23fff'%3E%3Cpath fill-rule='evenodd' d='M16.004 8A4 4 0 1 1 8 7.998 4 4 0 0 1 16.004 8Zm-2 0a2 2 0 1 0-4.001 0 2 2 0 0 0 4 0Zm5.892 10.55-1.89-3.89A3.001 3.001 0 0 0 15.263 13H8.742a3.001 3.001 0 0 0-2.691 1.66L4.11 18.55A1 1 0 0 0 5 20h14.006a1 1 0 0 0 .89-1.45Zm-12.055-3L6.621 18h10.764l-1.22-2.45a1 1 0 0 0-.9-.55H8.741a1 1 0 0 0-.9.55Z' clip-rule='evenodd'/%3E%3C/svg%3E");
}

/* .UiTabs-tabs-3VpC span.custom {
    background: #eef1f3;
    color: #636f7f;
} */
.UiTabs-tabs-3VpC span.brak12 {
   
  background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24'  fill='%236528D7'%3E%3Cpath fill-rule='evenodd'  d='M16.004 8A4 4 0 1 1 8 7.998 4 4 0 0 1 16.004 8Zm-2 0a2 2 0 1 0-4.001 0 2 2 0 0 0 4 0Zm5.892 10.55-1.89-3.89A3.001 3.001 0 0 0 15.263 13H8.742a3.001 3.001 0 0 0-2.691 1.66L4.11 18.55A1 1 0 0 0 5 20h14.006a1 1 0 0 0 .89-1.45Zm-12.055-3L6.621 18h10.764l-1.22-2.45a1 1 0 0 0-.9-.55H8.741a1 1 0 0 0-.9.55Z' clip-rule='evenodd'/%3E%3C/svg%3E");

}
div.new, 
div.approval, 
div.delivery, 
div.cancel, 
div.complete, 
div.dflkdslskl, 
div.assembling, 
div.brak12, 
div.sto12f {
      border-radius: 4px;
    font-size: 14px;
    height: 32px;
    line-height: 32px;
    overflow: hidden;
    padding: 0 12px 0 40px;
    position: relative;
    text-overflow: ellipsis;
    white-space: nowrap;
}
div.new .statis, 
div.approval .statis, 
div.delivery .statis, 
div.cancel .statis, 
div.complete .statis, 
div.dflkdslskl .statis, 
div.assembling .statis, 
div.brak12 .statis, 
div.sto12f .statis {
  background-position: 50%;
    background-repeat: no-repeat;
    height: 24px;
    left: 13px;
    margin-top: -12px;
    position: absolute;
    top: 50%;
    width: 24px;
} 

div.new {
  color: #fff;;
}
</style>
